import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Spinner, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import firebase from '../tools/firebase';
import logo from '../assets/LaunchScreen@2x.png';
import Footer from '../components/Footer';
import style from '../style/admin.module.css';

const TruckCard = ({ truck }) => (
    <div className={style.truckCard}>
        <div className={style.truckCardImageWrap}>
            {truck.image
                ? <img src={truck.image} alt={truck.title} className={style.truckCardImage} />
                : <div className={style.truckCardImagePlaceholder} />
            }
            <div className={style.truckCardOverlay}>
                <div className={style.truckCardBadges}>
                    {truck.active    && <span className={style.badgeActive}>● Active</span>}
                    {truck.published && <span className={style.badgePublished}>Published</span>}
                </div>
                <h3 className={style.truckCardName}>{truck.title}</h3>
            </div>
        </div>
        <div className={style.truckCardFooter}>
            <Link to={`/admin/trucks/${truck.id}`}>
                <Button className={style.primaryBtn} block>Manage Truck →</Button>
            </Link>
        </div>
    </div>
);

const AdminDashboard = ({ history }) => {
    const [trucks, setTrucks]   = useState([]);
    const [loading, setLoading] = useState(true);
    const [queryUid, setQueryUid] = useState('');
    const [error, setError]     = useState('');

    useEffect(() => {
        const unsubscribe = firebase.auth().onAuthStateChanged(user => {
            if (!user) { history.push('/admin'); return; }
            setQueryUid(user.uid);
            firebase.firestore()
                .collection('trucks')
                .where('ownerID', '==', user.uid)
                .get()
                .then(snap => {
                    const list = [];
                    snap.forEach(doc => list.push({ id: doc.id, ...doc.data() }));
                    setTrucks(list);
                })
                .catch(err => setError(err.message))
                .finally(() => setLoading(false));
        });
        return unsubscribe;
    }, [history]);

    const handleSignOut = () => {
        firebase.auth().signOut().then(() => history.push('/admin'));
    };

    return (
        <div className={style.dashboardPage}>
            <div className={style.dashHero}>
                <Container>
                    <div className={style.dashHeroInner}>
                        <img src={logo} alt="Grub Trucks" className={style.dashLogo} />
                        <div className={style.dashHeroText}>
                            <h1 className={style.dashHeroTitle}>My Trucks</h1>
                            {!loading && !error && (
                                <p className={style.dashHeroSub}>
                                    {trucks.length} {trucks.length === 1 ? 'truck' : 'trucks'} in your account
                                </p>
                            )}
                        </div>
                        <Button className={style.signOutBtn} onClick={handleSignOut}>
                            Sign Out
                        </Button>
                    </div>
                </Container>
            </div>

            <Container className={style.pageContent}>
                {error && (
                    <Alert variant="danger">
                        <strong>Firestore error:</strong> {error}
                    </Alert>
                )}

                {loading ? (
                    <div className={style.centered}>
                        <div className={style.spinner} />
                    </div>
                ) : trucks.length === 0 ? (
                    <div className={style.emptyState}>
                        <div className={style.emptyIcon}>🚚</div>
                        <p className={style.emptyMsg}>No trucks found for your account.</p>
                        <p className={style.debugMsg}>Queried <code>ownerID == "{queryUid}"</code></p>
                    </div>
                ) : (
                    <Row>
                        {trucks.map(truck => (
                            <Col key={truck.id} xs={12} sm={6} lg={4} className="mb-4">
                                <TruckCard truck={truck} />
                            </Col>
                        ))}
                    </Row>
                )}
            </Container>
            <Footer />
        </div>
    );
};

export default AdminDashboard;
